/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  CheckoutDeliveryAddressAdapter,
  CheckoutDeliveryModesAdapter,
  CheckoutPaymentAdapter
} from '@spartacus/checkout/base/core';
import { provideConfig } from '@spartacus/core';
import { CustomOccCheckoutPaymentAdapter } from '../../../occ/adapters/checkout/custom-occ-checkout-payment.adapter';
import { CustomOccCheckoutAdapter } from '../../../occ/adapters/checkout/custom-occ-checkout.adapter';
import { CustomCheckoutAdapter } from '../connectors/custom-checkout.adapter';
import { CustomOccCheckoutDeliveryAddressAdapter } from '../converters/occ-checkout-delivery-address.adapter';
import { CustomOccCheckoutDeliveryModesAdapter } from '../converters/occ-checkout-delivery-modes.adapter';
import { customDefaultOccCheckoutConfig } from './config/custom-default-occ-checkout-config';

@NgModule({
  imports: [CommonModule],
  providers: [
    provideConfig(customDefaultOccCheckoutConfig),
    {
      provide: CustomCheckoutAdapter,
      useClass: CustomOccCheckoutAdapter,
    },
    {
      provide: CheckoutDeliveryAddressAdapter,
      useClass: CustomOccCheckoutDeliveryAddressAdapter,
    },
    {
      provide: CheckoutDeliveryModesAdapter,
      useClass: CustomOccCheckoutDeliveryModesAdapter,
    },
    {
      provide: CheckoutPaymentAdapter,
      useClass: CustomOccCheckoutPaymentAdapter,
    },
  ],
})
export class CustomCheckoutOccModule { }
